import { render, staticRenderFns } from "./SuppliersManagement.vue?vue&type=template&id=918ea18e&scoped=true"
import script from "./SuppliersManagement.vue?vue&type=script&lang=js"
export * from "./SuppliersManagement.vue?vue&type=script&lang=js"
import style0 from "./SuppliersManagement.vue?vue&type=style&index=0&id=918ea18e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918ea18e",
  null
  
)

export default component.exports